import { axiosWithAuth } from "helpers";

export const splitProfileListService = {
	getSplitProfileList,
	changeSplitProfileStatus,
	updateSplitProfileDefault,
};

const API_URL = process.env.REACT_APP_API_URL;
const PAGE_SIZE = 50;

function getSplitProfileList({ agentId, page, sortBy, sortDescending }) {
	const options = {
		method: "GET",
		params: {
			page_index: page,
			page_size: PAGE_SIZE,
			sort_by: sortBy,
			ascending: sortDescending,
		},
		url: `${API_URL}/api/agents/${agentId}/residuals/split_profiles`,
	};

	return axiosWithAuth(options);
}

function changeSplitProfileStatus({ agentId, splitProfileId, status }) {
	return axiosWithAuth({
		url: `${API_URL}/api/agents/${agentId}/residuals/split_profiles/${splitProfileId}/update_status`,
		method: "PUT",
		data: { is_active: status },
	});
}

function updateSplitProfileDefault({ agentId, splitProfileId, isDefault }) {
	return axiosWithAuth({
		url: `${API_URL}/api/agents/${agentId}/residuals/split_profiles/${splitProfileId}/set_is_default`,
		method: "POST",
		data: { is_default: isDefault },
	});
}
